import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  getters: {
    getFavoriteByProviderId: (state) => (id) => {
      return state.favorites.find(favorite => favorite.provider_id === id)
    }
  },

  state: {
    customer: null,
    isAuthenticated: false,
    alert: false,
    alertType: 'success',
    alertText: '',
    care_account_success: false,
    profile: null,
    confirmed: false,
    favorites: [],
    fullscreen: false,
    lists: [],
    navBarProgressIsVisible: false,
    progressBarValue: 0,
    providers: {},
    search: {},
  },

  mutations: {
    addFavorite (state, favorite) {
      state.favorites.push(favorite)
    },

    addList (state, list) {
      state.lists.push(list)
    },

    addProvider (state, provider) {
      state.providers[provider.id] = provider
    },

    addSearch (state, search) {
      state.profile.searches.push(search)
    },

    fullscreen (state, active) {
      state.fullscreen = active
    },

    hide (state, dialog) {
      state[dialog + 'IsVisible'] = false
    },

    hideAlert (state) {
      state.alert = false
    },

    removeFavorite (state, favorite) {
      state.favorites.splice(state.favorites.indexOf(function(f) { f.id == favorite.id }))
    },

    setProfile (state, profile) {
      state.profile = profile
      state.confirmed = profile.confirmed
    },

    setProgressBarValue (state, amount) {
      state.progressBarValue = amount
    },

    setSearch(state, search) {
      state.search = search
    },

    showAlert (state, text) {
      state.alertText = text
      state.alert = true
    },

    show (state, dialog) {
      state[dialog + 'IsVisible'] = true
    },

    updateFavorites (state, favorites) {
      state.favorites = favorites
    },

    updateLists (state, lists) {
      state.lists = lists
    },
    setCustomer(state, payload) {
      state.customer = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setIsCustomer(state, payload) {
      state.isCustomer = payload;
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
})
